import { Pipe, PipeTransform } from '@angular/core';
import { contrastInk } from '../theme-service/branding-css';

/**
 * Resolves black or white text ink for a customizable background color so the
 * text holds a readable WCAG contrast ratio against it. Accepts a hex color with
 * or without a leading '#'; a nullish or empty value falls back to the neutral
 * gray used for badges without a configured status color.
 */
@Pipe({
    name: 'contrastInk',
})
export class ContrastInkPipe implements PipeTransform {
    /**
     * @param color - Background hex color (with or without '#'), or nullish for the gray fallback.
     * @returns '#000000' or '#ffffff'.
     */
    transform(color: string | null | undefined): string {
        return contrastInk(color?.trim() ? color : '808080');
    }
}
